<template>
  <div :class="styles.col">
    <div class="term-box" :class="{ active }">
      <slot name="text"></slot>
      <slot name="price"></slot>
      <slot name="subtext"></slot>
      <slot name="reccomended"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectBox',

  props: {
    active: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default() {
        return {
          col: ''
        };
      }
    }
  }
};
</script>
